import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import { VuetifyTheme } from '~/utils';
export { Vuetify, VuetifyTheme };
